import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Checkbox connected to ReduxForm.
 * @param  {Array}  children         children passed to the component (in this case it's made for an other field depending on this one
 * @param  {Object} input            Containing name value and the rest of props (cf. redux form)
 * @param  {String} id               Identifier of input
 * @param  {String} label            Label to render next to the checkbox
 * @return {ReactComponent} Checkbox
 */
const Checkbox = ({
    children,
    input: { name, value, onBlur, ...rest },
    id,
    label,
    sublabel,
    className,
    inlineSub,
}) => {
    const containerClasses = classnames(className, {
        'label-container': true,
    });

    return (
        <div className={containerClasses}>
            <input
                id={id}
                name={name}
                {...rest}
                type="checkbox"
                className="checkbox"
                checked={value}
                onClick={onBlur}
            />
            <label htmlFor={id} className="label label--checkbox">
                <div className="label--content">
                    <span className="margin-right-half">{label}</span>
                    {sublabel && (
                        <p className={`sublabel ${inlineSub ? 'inline-block' : ''}`}>{sublabel}</p>
                    )}
                </div>
            </label>
            {children}
        </div>
    );
};

Checkbox.displayName = 'Checkbox';

Checkbox.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    inlineSub: PropTypes.bool,
    input: PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        onBlur: PropTypes.func,
    }).isRequired,
};

Checkbox.defaultProps = {
    inlineSub: true,
};

/**
 * Checkbox Functional Component for the form
 */
export default Checkbox;
